export default "__VITE_ASSET__C7n1ydY9__"